"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.run(function (tlSelectConfigRegistry, currencySelectConfig) {
  tlSelectConfigRegistry.registerConfig("currency", currencySelectConfig);
});
ngModule.factory("currencySelectConfig", function () {
  return {
    idAttribute: "isoCode",
    groupBy: "majorCurrency",
    optionTemplate: require("./currencyOption.html"),
    groupLabelTemplate: require("./currencyGroupLabel.html")
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/selectbox/configs/currencies/currencySelectConfig.js
// module id = 2993
// module chunks = 13